import { render, staticRenderFns } from "./UserOrderAftersale.vue?vue&type=template&id=02aa818c&"
import script from "./UserOrderAftersale.vue?vue&type=script&lang=js&"
export * from "./UserOrderAftersale.vue?vue&type=script&lang=js&"
import style0 from "./UserOrderAftersale.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports